import { ShieldCheck, ShieldOff, ShieldQuestion } from "lucide-react";

export const consentStatus = (c) => c?.marketing_status || (c?.marketing_consent === true ? "attivo" : c?.marketing_revoked_at ? "revocato" : "assente");

const META = {
  attivo: { label: "Consenso attivo", cls: "bg-emerald-50 text-emerald-700 border-emerald-200", icon: ShieldCheck },
  assente: { label: "Consenso assente", cls: "bg-slate-100 text-slate-500 border-slate-200", icon: ShieldQuestion },
  revocato: { label: "Consenso revocato", cls: "bg-rose-50 text-rose-700 border-rose-200", icon: ShieldOff },
};

export const ConsentBadge = ({ client, testid }) => {
  const s = consentStatus(client);
  const { label, cls, icon: I } = META[s];
  const date = s === "revocato" ? ` il ${new Date(client.marketing_revoked_at).toLocaleDateString("it-IT")}` : "";
  return (
    <span data-testid={testid} data-status={s} title={`Marketing: ${label.toLowerCase()}${date}`}
      className={`inline-flex items-center gap-1 whitespace-nowrap text-[11px] px-2 py-1 rounded-md border ${cls}`}>
      <I className="h-3.5 w-3.5" />{label}{date}
    </span>
  );
};
